// One-time axios configuration: cookies + view-as query param injection.
// Imported for side-effects from index.js so it runs before any component
// mounts and fires its first request.
import axios from 'axios';
import { getViewAs } from './viewAs';

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const target = getViewAs();
  if (target && target.user_id) {
    config.params = { ...(config.params || {}), as_user_id: target.user_id };
  }
  return config;
});
